import { render, staticRenderFns } from "./CocRecord.vue?vue&type=template&id=4b19d7a8&scoped=true"
import script from "./CocRecord.vue?vue&type=script&lang=js"
export * from "./CocRecord.vue?vue&type=script&lang=js"
import style0 from "./CocRecord.vue?vue&type=style&index=0&id=4b19d7a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b19d7a8",
  null
  
)

export default component.exports